import showH2H from './showH2H.jst';
import showOpen from './showOpen.jst';
import joinH2H from './joinH2H.jst';
import joinOpen from './joinOpen.jst';
import regenerateH2H from './regenerateH2H.jst';
import regenerateOpen from './regenerateOpen.jst';

export default {
	showH2H,
	showOpen,
	joinH2H,
	joinOpen,
	regenerateH2H,
	regenerateOpen
};